//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class Client {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @return OK
   */
  connectionsGET(): Observable<Connections> {
    let url_ = this.baseUrl + '/api/connections';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConnectionsGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConnectionsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Connections>;
            }
          } else return _observableThrow(response_) as any as Observable<Connections>;
        }),
      );
  }

  protected processConnectionsGET(response: HttpResponseBase): Observable<Connections> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Connections.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  connectionsPOST(id: string): Observable<Connections> {
    let url_ = this.baseUrl + '/api/connections/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConnectionsPOST(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConnectionsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Connections>;
            }
          } else return _observableThrow(response_) as any as Observable<Connections>;
        }),
      );
  }

  protected processConnectionsPOST(response: HttpResponseBase): Observable<Connections> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Connections.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  connectionsDELETE(id: string): Observable<Connections> {
    let url_ = this.baseUrl + '/api/connections/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConnectionsDELETE(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConnectionsDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Connections>;
            }
          } else return _observableThrow(response_) as any as Observable<Connections>;
        }),
      );
  }

  protected processConnectionsDELETE(response: HttpResponseBase): Observable<Connections> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Connections.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param viewed (optional)
   * @return OK
   */
  messagesAll(viewed: boolean | undefined): Observable<ConversationPreview[]> {
    let url_ = this.baseUrl + '/api/messages?';
    if (viewed === null) throw new globalThis.Error("The parameter 'viewed' cannot be null.");
    else if (viewed !== undefined) url_ += 'viewed=' + encodeURIComponent('' + viewed) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMessagesAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMessagesAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ConversationPreview[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ConversationPreview[]>;
        }),
      );
  }

  protected processMessagesAll(response: HttpResponseBase): Observable<ConversationPreview[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ConversationPreview.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  messagesPOST(body: SendMessage | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/messages';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMessagesPOST(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMessagesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMessagesPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  messagesGET(w: string): Observable<Conversation> {
    let url_ = this.baseUrl + '/api/messages/{with}';
    if (w === undefined || w === null) throw new globalThis.Error("The parameter 'with' must be defined.");
    url_ = url_.replace('{with}', encodeURIComponent('' + w));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMessagesGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMessagesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Conversation>;
            }
          } else return _observableThrow(response_) as any as Observable<Conversation>;
        }),
      );
  }

  protected processMessagesGET(response: HttpResponseBase): Observable<Conversation> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Conversation.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param channel_name (optional)
   * @param socket_id (optional)
   * @return OK
   */
  auth(channel_name: string | undefined, socket_id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/messages/auth';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (channel_name === null || channel_name === undefined) throw new globalThis.Error("The parameter 'channel_name' cannot be null.");
    else content_.append('channel_name', channel_name.toString());
    if (socket_id === null || socket_id === undefined) throw new globalThis.Error("The parameter 'socket_id' cannot be null.");
    else content_.append('socket_id', socket_id.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuth(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAuth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param user_id (optional)
   * @return OK
   */
  beamsAuthGET(user_id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/messages/beams-auth?';
    if (user_id === null) throw new globalThis.Error("The parameter 'user_id' cannot be null.");
    else if (user_id !== undefined) url_ += 'user_id=' + encodeURIComponent('' + user_id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBeamsAuthGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBeamsAuthGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processBeamsAuthGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  beamsAuthDELETE(): Observable<void> {
    let url_ = this.baseUrl + '/api/messages/beams-auth';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBeamsAuthDELETE(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBeamsAuthDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processBeamsAuthDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  summary(id: string): Observable<MetricsSummary> {
    let url_ = this.baseUrl + '/api/profiles/{id}/metrics/summary';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSummary(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSummary(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MetricsSummary>;
            }
          } else return _observableThrow(response_) as any as Observable<MetricsSummary>;
        }),
      );
  }

  protected processSummary(response: HttpResponseBase): Observable<MetricsSummary> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MetricsSummary.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return No Content
   */
  verificationRequestPOST(body: RequestVerificationBody | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/payments/verification-request';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerificationRequestPOST(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerificationRequestPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processVerificationRequestPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  verificationRequestGET(): Observable<GetMyVerificationRequestResult> {
    let url_ = this.baseUrl + '/api/payments/verification-request';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerificationRequestGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerificationRequestGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetMyVerificationRequestResult>;
            }
          } else return _observableThrow(response_) as any as Observable<GetMyVerificationRequestResult>;
        }),
      );
  }

  protected processVerificationRequestGET(response: HttpResponseBase): Observable<GetMyVerificationRequestResult> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetMyVerificationRequestResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  checkout(): Observable<CreateStripeCheckoutResult> {
    let url_ = this.baseUrl + '/api/payments/stripe/checkout';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckout(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckout(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateStripeCheckoutResult>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateStripeCheckoutResult>;
        }),
      );
  }

  protected processCheckout(response: HttpResponseBase): Observable<CreateStripeCheckoutResult> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CreateStripeCheckoutResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  webhook(): Observable<void> {
    let url_ = this.baseUrl + '/api/payments/stripe/webhook';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processWebhook(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processWebhook(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processWebhook(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  payment(): Observable<GetMyPaymentResult> {
    let url_ = this.baseUrl + '/api/payments/payment';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPayment(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPayment(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetMyPaymentResult>;
            }
          } else return _observableThrow(response_) as any as Observable<GetMyPaymentResult>;
        }),
      );
  }

  protected processPayment(response: HttpResponseBase): Observable<GetMyPaymentResult> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetMyPaymentResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  portal(): Observable<CreateStripePortalSessionResult> {
    let url_ = this.baseUrl + '/api/payments/stripe/portal';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPortal(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPortal(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateStripePortalSessionResult>;
            }
          } else return _observableThrow(response_) as any as Observable<CreateStripePortalSessionResult>;
        }),
      );
  }

  protected processPortal(response: HttpResponseBase): Observable<CreateStripePortalSessionResult> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CreateStripePortalSessionResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  profilesPOST(body: RegisterProfile | undefined): Observable<Profile> {
    let url_ = this.baseUrl + '/api/profiles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilesPOST(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Profile>;
            }
          } else return _observableThrow(response_) as any as Observable<Profile>;
        }),
      );
  }

  protected processProfilesPOST(response: HttpResponseBase): Observable<Profile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Profile.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  profilesPUT(body: UpdateProfile | undefined): Observable<Profile> {
    let url_ = this.baseUrl + '/api/profiles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilesPUT(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Profile>;
            }
          } else return _observableThrow(response_) as any as Observable<Profile>;
        }),
      );
  }

  protected processProfilesPUT(response: HttpResponseBase): Observable<Profile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Profile.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  profilesDELETE(): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilesDELETE(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilesDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processProfilesDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  profilesGET(): Observable<Profile> {
    let url_ = this.baseUrl + '/api/profiles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilesGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Profile>;
            }
          } else return _observableThrow(response_) as any as Observable<Profile>;
        }),
      );
  }

  protected processProfilesGET(response: HttpResponseBase): Observable<Profile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Profile.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  search(body: SearchCriteria | undefined): Observable<SearchResult[]> {
    let url_ = this.baseUrl + '/api/profiles/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchResult[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchResult[]>;
        }),
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<SearchResult[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(SearchResult.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  profilesGET2(id: string): Observable<SearchResult> {
    let url_ = this.baseUrl + '/api/profiles/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilesGET2(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchResult>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchResult>;
        }),
      );
  }

  protected processProfilesGET2(response: HttpResponseBase): Observable<SearchResult> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  reports(body: ReportProfile | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/reports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReports(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReports(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processReports(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  blocks(body: BlockProfile | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/blocks';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBlocks(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBlocks(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processBlocks(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  views(): Observable<ProfileView[]> {
    let url_ = this.baseUrl + '/api/profiles/views';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processViews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processViews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProfileView[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProfileView[]>;
        }),
      );
  }

  protected processViews(response: HttpResponseBase): Observable<ProfileView[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProfileView.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  ratings(id: string): Observable<ProfileView[]> {
    let url_ = this.baseUrl + '/api/profiles/ratings/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRatings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRatings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProfileView[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProfileView[]>;
        }),
      );
  }

  protected processRatings(response: HttpResponseBase): Observable<ProfileView[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProfileView.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  ratePOST(body: AddRating | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/rate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRatePOST(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRatePOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processRatePOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  rateDELETE(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/rate/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRateDELETE(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRateDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processRateDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  notificationPreferencesGET(): Observable<NotificationPreferences> {
    let url_ = this.baseUrl + '/api/profiles/notification-preferences';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNotificationPreferencesGET(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNotificationPreferencesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NotificationPreferences>;
            }
          } else return _observableThrow(response_) as any as Observable<NotificationPreferences>;
        }),
      );
  }

  protected processNotificationPreferencesGET(response: HttpResponseBase): Observable<NotificationPreferences> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NotificationPreferences.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  notificationPreferencesPUT(body: UpdateNotificationPreferences | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/notification-preferences';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNotificationPreferencesPUT(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNotificationPreferencesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processNotificationPreferencesPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  club(): Observable<Club> {
    let url_ = this.baseUrl + '/api/profile-types/club';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClub(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClub(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Club>;
            }
          } else return _observableThrow(response_) as any as Observable<Club>;
        }),
      );
  }

  protected processClub(response: HttpResponseBase): Observable<Club> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Club.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  manager(): Observable<Manager> {
    let url_ = this.baseUrl + '/api/profile-types/manager';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processManager(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processManager(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Manager>;
            }
          } else return _observableThrow(response_) as any as Observable<Manager>;
        }),
      );
  }

  protected processManager(response: HttpResponseBase): Observable<Manager> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Manager.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  staff(): Observable<Staff> {
    let url_ = this.baseUrl + '/api/profile-types/staff';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStaff(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStaff(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Staff>;
            }
          } else return _observableThrow(response_) as any as Observable<Staff>;
        }),
      );
  }

  protected processStaff(response: HttpResponseBase): Observable<Staff> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Staff.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  player(): Observable<Player> {
    let url_ = this.baseUrl + '/api/profile-types/player';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPlayer(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPlayer(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Player>;
            }
          } else return _observableThrow(response_) as any as Observable<Player>;
        }),
      );
  }

  protected processPlayer(response: HttpResponseBase): Observable<Player> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Player.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  coach(): Observable<Coach> {
    let url_ = this.baseUrl + '/api/profile-types/coach';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCoach(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCoach(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Coach>;
            }
          } else return _observableThrow(response_) as any as Observable<Coach>;
        }),
      );
  }

  protected processCoach(response: HttpResponseBase): Observable<Coach> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Coach.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class IntroClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param video (optional)
   * @param thumbnail (optional)
   * @param duration (optional)
   * @param video (optional)
   * @return OK
   */
  video(video: FileParameter | undefined, thumbnail: string | undefined, duration: number | undefined, video2: FileParameter | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/upload_intro_video';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (video === null || video === undefined) throw new globalThis.Error("The parameter 'video' cannot be null.");
    else content_.append('Video', video.data, video.fileName ? video.fileName : 'Video');
    if (thumbnail === null || thumbnail === undefined) throw new globalThis.Error("The parameter 'thumbnail' cannot be null.");
    else content_.append('Thumbnail', thumbnail.toString());
    if (duration === null || duration === undefined) throw new globalThis.Error("The parameter 'duration' cannot be null.");
    else content_.append('Duration', duration.toString());
    if (video2 === null || video2 === undefined) throw new globalThis.Error("The parameter 'video2' cannot be null.");
    else content_.append('Video2', video2.data, video2.fileName ? video2.fileName : 'Video2');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVideo(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVideo(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processVideo(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  video2(): Observable<void> {
    let url_ = this.baseUrl + '/api/profiles/delete_intro_video';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVideo2(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVideo2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processVideo2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ValidationProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        }),
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class AddRating implements IAddRating {
  profileId?: string;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  comment?: string | undefined;

  constructor(data?: IAddRating) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data['profileId'];
      this.rateTactic = _data['rateTactic'];
      this.ratePhysic = _data['ratePhysic'];
      this.rateTechnique = _data['rateTechnique'];
      this.rateMental = _data['rateMental'];
      this.rateCompromise = _data['rateCompromise'];
      this.comment = _data['comment'];
    }
  }

  static fromJS(data: any): AddRating {
    data = typeof data === 'object' ? data : {};
    let result = new AddRating();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileId'] = this.profileId;
    data['rateTactic'] = this.rateTactic;
    data['ratePhysic'] = this.ratePhysic;
    data['rateTechnique'] = this.rateTechnique;
    data['rateMental'] = this.rateMental;
    data['rateCompromise'] = this.rateCompromise;
    data['comment'] = this.comment;
    return data;
  }
}

export interface IAddRating {
  profileId?: string;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  comment?: string | undefined;
}

export class Block implements IBlock {
  readonly id?: number;
  readonly profileId?: string;
  readonly blockedProfileId?: string;
  readonly blockedOn?: Date;
  readonly reason?: string | undefined;

  constructor(data?: IBlock) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (this as any).id = _data['id'];
      (this as any).profileId = _data['profileId'];
      (this as any).blockedProfileId = _data['blockedProfileId'];
      (this as any).blockedOn = _data['blockedOn'] ? new Date(_data['blockedOn'].toString()) : (undefined as any);
      (this as any).reason = _data['reason'];
    }
  }

  static fromJS(data: any): Block {
    data = typeof data === 'object' ? data : {};
    let result = new Block();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['profileId'] = this.profileId;
    data['blockedProfileId'] = this.blockedProfileId;
    data['blockedOn'] = this.blockedOn ? this.blockedOn.toISOString() : (undefined as any);
    data['reason'] = this.reason;
    return data;
  }
}

export interface IBlock {
  id?: number;
  profileId?: string;
  blockedProfileId?: string;
  blockedOn?: Date;
  reason?: string | undefined;
}

export class BlockProfile implements IBlockProfile {
  id?: string;
  reason?: string | undefined;

  constructor(data?: IBlockProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reason = _data['reason'];
    }
  }

  static fromJS(data: any): BlockProfile {
    data = typeof data === 'object' ? data : {};
    let result = new BlockProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reason'] = this.reason;
    return data;
  }
}

export interface IBlockProfile {
  id?: string;
  reason?: string | undefined;
}

export enum Category {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class Club implements IClub {
  teamData?: TeamData;
  economicConditions?: EconomicConditions;
  federationClubNumber?: string | undefined;

  constructor(data?: IClub) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.teamData = _data['teamData'] ? TeamData.fromJS(_data['teamData']) : (undefined as any);
      this.economicConditions = _data['economicConditions'] ? EconomicConditions.fromJS(_data['economicConditions']) : (undefined as any);
      this.federationClubNumber = _data['federationClubNumber'];
    }
  }

  static fromJS(data: any): Club {
    data = typeof data === 'object' ? data : {};
    let result = new Club();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['teamData'] = this.teamData ? this.teamData.toJSON() : (undefined as any);
    data['economicConditions'] = this.economicConditions ? this.economicConditions.toJSON() : (undefined as any);
    data['federationClubNumber'] = this.federationClubNumber;
    return data;
  }
}

export interface IClub {
  teamData?: TeamData;
  economicConditions?: EconomicConditions;
  federationClubNumber?: string | undefined;
}

export class Coach implements ICoach {
  personalData?: PersonalData;
  training?: CoachTraning;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;

  constructor(data?: ICoach) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.personalData = _data['personalData'] ? PersonalData.fromJS(_data['personalData']) : (undefined as any);
      this.training = _data['training'];
      this.teamData = _data['teamData'] ? TeamData.fromJS(_data['teamData']) : (undefined as any);
      this.teamType = _data['teamType'];
      this.status = _data['status'];
      if (Array.isArray(_data['lastSeasonsData'])) {
        this.lastSeasonsData = [] as any;
        for (let item of _data['lastSeasonsData']) this.lastSeasonsData!.push(LastSeasonsData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Coach {
    data = typeof data === 'object' ? data : {};
    let result = new Coach();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['personalData'] = this.personalData ? this.personalData.toJSON() : (undefined as any);
    data['training'] = this.training;
    data['teamData'] = this.teamData ? this.teamData.toJSON() : (undefined as any);
    data['teamType'] = this.teamType;
    data['status'] = this.status;
    if (Array.isArray(this.lastSeasonsData)) {
      data['lastSeasonsData'] = [];
      for (let item of this.lastSeasonsData) data['lastSeasonsData'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICoach {
  personalData?: PersonalData;
  training?: CoachTraning;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;
}

export enum CoachTraning {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export class Connections implements IConnections {
  following?: ProfileReadModel[] | undefined;
  followers?: ProfileReadModel[] | undefined;

  constructor(data?: IConnections) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['following'])) {
        this.following = [] as any;
        for (let item of _data['following']) this.following!.push(ProfileReadModel.fromJS(item));
      }
      if (Array.isArray(_data['followers'])) {
        this.followers = [] as any;
        for (let item of _data['followers']) this.followers!.push(ProfileReadModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Connections {
    data = typeof data === 'object' ? data : {};
    let result = new Connections();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.following)) {
      data['following'] = [];
      for (let item of this.following) data['following'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.followers)) {
      data['followers'] = [];
      for (let item of this.followers) data['followers'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IConnections {
  following?: ProfileReadModel[] | undefined;
  followers?: ProfileReadModel[] | undefined;
}

export class Conversation implements IConversation {
  profile1Id?: string;
  profile2Id?: string;
  profile1Viewed?: boolean;
  profile2Viewed?: boolean;
  profile1LastViewedAt?: Date;
  profile2LastViewedAt?: Date;
  chatMessages?: Message[] | undefined;

  constructor(data?: IConversation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profile1Id = _data['profile1Id'];
      this.profile2Id = _data['profile2Id'];
      this.profile1Viewed = _data['profile1Viewed'];
      this.profile2Viewed = _data['profile2Viewed'];
      this.profile1LastViewedAt = _data['profile1LastViewedAt'] ? new Date(_data['profile1LastViewedAt'].toString()) : (undefined as any);
      this.profile2LastViewedAt = _data['profile2LastViewedAt'] ? new Date(_data['profile2LastViewedAt'].toString()) : (undefined as any);
      if (Array.isArray(_data['chatMessages'])) {
        this.chatMessages = [] as any;
        for (let item of _data['chatMessages']) this.chatMessages!.push(Message.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Conversation {
    data = typeof data === 'object' ? data : {};
    let result = new Conversation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profile1Id'] = this.profile1Id;
    data['profile2Id'] = this.profile2Id;
    data['profile1Viewed'] = this.profile1Viewed;
    data['profile2Viewed'] = this.profile2Viewed;
    data['profile1LastViewedAt'] = this.profile1LastViewedAt ? this.profile1LastViewedAt.toISOString() : (undefined as any);
    data['profile2LastViewedAt'] = this.profile2LastViewedAt ? this.profile2LastViewedAt.toISOString() : (undefined as any);
    if (Array.isArray(this.chatMessages)) {
      data['chatMessages'] = [];
      for (let item of this.chatMessages) data['chatMessages'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IConversation {
  profile1Id?: string;
  profile2Id?: string;
  profile1Viewed?: boolean;
  profile2Viewed?: boolean;
  profile1LastViewedAt?: Date;
  profile2LastViewedAt?: Date;
  chatMessages?: Message[] | undefined;
}

export class ConversationPreview implements IConversationPreview {
  profileId?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  lastChatMessage?: Message;
  viewed?: boolean;
  profileVerified?: boolean;

  constructor(data?: IConversationPreview) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data['profileId'];
      this.type = _data['type'];
      this.profileData = _data['profileData'];
      this.profilePicture = _data['profilePicture'];
      this.lastChatMessage = _data['lastChatMessage'] ? Message.fromJS(_data['lastChatMessage']) : (undefined as any);
      this.viewed = _data['viewed'];
      this.profileVerified = _data['profileVerified'];
    }
  }

  static fromJS(data: any): ConversationPreview {
    data = typeof data === 'object' ? data : {};
    let result = new ConversationPreview();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileId'] = this.profileId;
    data['type'] = this.type;
    data['profileData'] = this.profileData;
    data['profilePicture'] = this.profilePicture;
    data['lastChatMessage'] = this.lastChatMessage ? this.lastChatMessage.toJSON() : (undefined as any);
    data['viewed'] = this.viewed;
    data['profileVerified'] = this.profileVerified;
    return data;
  }
}

export interface IConversationPreview {
  profileId?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  lastChatMessage?: Message;
  viewed?: boolean;
  profileVerified?: boolean;
}

export class CreateStripeCheckoutResult implements ICreateStripeCheckoutResult {
  url?: string | undefined;

  constructor(data?: ICreateStripeCheckoutResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url'];
    }
  }

  static fromJS(data: any): CreateStripeCheckoutResult {
    data = typeof data === 'object' ? data : {};
    let result = new CreateStripeCheckoutResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['url'] = this.url;
    return data;
  }
}

export interface ICreateStripeCheckoutResult {
  url?: string | undefined;
}

export class CreateStripePortalSessionResult implements ICreateStripePortalSessionResult {
  url?: string | undefined;

  constructor(data?: ICreateStripePortalSessionResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url'];
    }
  }

  static fromJS(data: any): CreateStripePortalSessionResult {
    data = typeof data === 'object' ? data : {};
    let result = new CreateStripePortalSessionResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['url'] = this.url;
    return data;
  }
}

export interface ICreateStripePortalSessionResult {
  url?: string | undefined;
}

export enum Division {
  _0 = 0,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
  _14 = 14,
  _20 = 20,
  _21 = 21,
  _22 = 22,
  _23 = 23,
  _24 = 24,
  _30 = 30,
  _31 = 31,
  _32 = 32,
  _33 = 33,
  _34 = 34,
  _35 = 35,
  _36 = 36,
  _37 = 37,
  _38 = 38,
}

export class EconomicConditions implements IEconomicConditions {
  bonus?: boolean;
  fuel?: boolean;
  accomodation?: boolean;
  food?: boolean;
  salary?: boolean;

  constructor(data?: IEconomicConditions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bonus = _data['bonus'];
      this.fuel = _data['fuel'];
      this.accomodation = _data['accomodation'];
      this.food = _data['food'];
      this.salary = _data['salary'];
    }
  }

  static fromJS(data: any): EconomicConditions {
    data = typeof data === 'object' ? data : {};
    let result = new EconomicConditions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['bonus'] = this.bonus;
    data['fuel'] = this.fuel;
    data['accomodation'] = this.accomodation;
    data['food'] = this.food;
    data['salary'] = this.salary;
    return data;
  }
}

export interface IEconomicConditions {
  bonus?: boolean;
  fuel?: boolean;
  accomodation?: boolean;
  food?: boolean;
  salary?: boolean;
}

export class GetMyPaymentResult implements IGetMyPaymentResult {
  id?: string;
  status?: PaymentStatus;
  provider?: PaymentProvider;
  createdAt?: Date;
  completedAt?: Date | undefined;
  verifiedUntil?: Date | undefined;

  constructor(data?: IGetMyPaymentResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.status = _data['status'];
      this.provider = _data['provider'];
      this.createdAt = _data['createdAt'] ? new Date(_data['createdAt'].toString()) : (undefined as any);
      this.completedAt = _data['completedAt'] ? new Date(_data['completedAt'].toString()) : (undefined as any);
      this.verifiedUntil = _data['verifiedUntil'] ? new Date(_data['verifiedUntil'].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): GetMyPaymentResult {
    data = typeof data === 'object' ? data : {};
    let result = new GetMyPaymentResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['status'] = this.status;
    data['provider'] = this.provider;
    data['createdAt'] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data['completedAt'] = this.completedAt ? this.completedAt.toISOString() : (undefined as any);
    data['verifiedUntil'] = this.verifiedUntil ? this.verifiedUntil.toISOString() : (undefined as any);
    return data;
  }
}

export interface IGetMyPaymentResult {
  id?: string;
  status?: PaymentStatus;
  provider?: PaymentProvider;
  createdAt?: Date;
  completedAt?: Date | undefined;
  verifiedUntil?: Date | undefined;
}

export class GetMyVerificationRequestResult implements IGetMyVerificationRequestResult {
  id?: string;
  status?: VerificationRequestStatus;
  requestedAt?: Date;
  reviewedAt?: Date | undefined;
  reviewerNote?: string | undefined;

  constructor(data?: IGetMyVerificationRequestResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.status = _data['status'];
      this.requestedAt = _data['requestedAt'] ? new Date(_data['requestedAt'].toString()) : (undefined as any);
      this.reviewedAt = _data['reviewedAt'] ? new Date(_data['reviewedAt'].toString()) : (undefined as any);
      this.reviewerNote = _data['reviewerNote'];
    }
  }

  static fromJS(data: any): GetMyVerificationRequestResult {
    data = typeof data === 'object' ? data : {};
    let result = new GetMyVerificationRequestResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['status'] = this.status;
    data['requestedAt'] = this.requestedAt ? this.requestedAt.toISOString() : (undefined as any);
    data['reviewedAt'] = this.reviewedAt ? this.reviewedAt.toISOString() : (undefined as any);
    data['reviewerNote'] = this.reviewerNote;
    return data;
  }
}

export interface IGetMyVerificationRequestResult {
  id?: string;
  status?: VerificationRequestStatus;
  requestedAt?: Date;
  reviewedAt?: Date | undefined;
  reviewerNote?: string | undefined;
}

export class LastSeasonsData implements ILastSeasonsData {
  total?: number;
  division?: Division;

  constructor(data?: ILastSeasonsData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.total = _data['total'];
      this.division = _data['division'];
    }
  }

  static fromJS(data: any): LastSeasonsData {
    data = typeof data === 'object' ? data : {};
    let result = new LastSeasonsData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['total'] = this.total;
    data['division'] = this.division;
    return data;
  }
}

export interface ILastSeasonsData {
  total?: number;
  division?: Division;
}

export enum Laterality {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class Location implements ILocation {
  x?: number;
  y?: number;

  constructor(data?: ILocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.x = _data['x'];
      this.y = _data['y'];
    }
  }

  static fromJS(data: any): Location {
    data = typeof data === 'object' ? data : {};
    let result = new Location();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['x'] = this.x;
    data['y'] = this.y;
    return data;
  }
}

export interface ILocation {
  x?: number;
  y?: number;
}

export class Manager implements IManager {
  personalData?: PersonalData;
  fifaNumber?: string | undefined;

  constructor(data?: IManager) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.personalData = _data['personalData'] ? PersonalData.fromJS(_data['personalData']) : (undefined as any);
      this.fifaNumber = _data['fifaNumber'];
    }
  }

  static fromJS(data: any): Manager {
    data = typeof data === 'object' ? data : {};
    let result = new Manager();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['personalData'] = this.personalData ? this.personalData.toJSON() : (undefined as any);
    data['fifaNumber'] = this.fifaNumber;
    return data;
  }
}

export interface IManager {
  personalData?: PersonalData;
  fifaNumber?: string | undefined;
}

export class Message implements IMessage {
  id?: string;
  content?: string | undefined;
  sentBy?: string;
  sentOn?: Date;

  constructor(data?: IMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.content = _data['content'];
      this.sentBy = _data['sentBy'];
      this.sentOn = _data['sentOn'] ? new Date(_data['sentOn'].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): Message {
    data = typeof data === 'object' ? data : {};
    let result = new Message();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['content'] = this.content;
    data['sentBy'] = this.sentBy;
    data['sentOn'] = this.sentOn ? this.sentOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IMessage {
  id?: string;
  content?: string | undefined;
  sentBy?: string;
  sentOn?: Date;
}

export class MetricsSummary implements IMetricsSummary {
  profileId?: string;
  profileViews?: number;
  newFollowers?: number;
  messagesReceived?: number;
  ratingsReceived?: number;
  appearedInSearch?: number;
  totalEvents?: number;
  since?: Date;

  constructor(data?: IMetricsSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data['profileId'];
      this.profileViews = _data['profileViews'];
      this.newFollowers = _data['newFollowers'];
      this.messagesReceived = _data['messagesReceived'];
      this.ratingsReceived = _data['ratingsReceived'];
      this.appearedInSearch = _data['appearedInSearch'];
      this.totalEvents = _data['totalEvents'];
      this.since = _data['since'] ? new Date(_data['since'].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): MetricsSummary {
    data = typeof data === 'object' ? data : {};
    let result = new MetricsSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileId'] = this.profileId;
    data['profileViews'] = this.profileViews;
    data['newFollowers'] = this.newFollowers;
    data['messagesReceived'] = this.messagesReceived;
    data['ratingsReceived'] = this.ratingsReceived;
    data['appearedInSearch'] = this.appearedInSearch;
    data['totalEvents'] = this.totalEvents;
    data['since'] = this.since ? this.since.toISOString() : (undefined as any);
    return data;
  }
}

export interface IMetricsSummary {
  profileId?: string;
  profileViews?: number;
  newFollowers?: number;
  messagesReceived?: number;
  ratingsReceived?: number;
  appearedInSearch?: number;
  totalEvents?: number;
  since?: Date;
}

export class NotificationPreferences implements INotificationPreferences {
  readonly profileId?: string;
  readonly globalEnabled?: boolean;
  readonly activityProfileViews?: boolean;
  readonly activityFollowers?: boolean;
  readonly activityMessages?: boolean;
  readonly activityRatings?: boolean;
  readonly activityFrequency?: string | undefined;
  readonly summaryDaily?: boolean;
  readonly summaryWeekly?: boolean;
  readonly marketingPromotions?: boolean;
  readonly pushEnabled?: boolean;
  readonly emailEnabled?: boolean;
  readonly acceptPolicies?: boolean | undefined;
  readonly acceptPoliciesTimestamp?: string | undefined;
  readonly acceptNotifications?: boolean | undefined;

  constructor(data?: INotificationPreferences) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (this as any).profileId = _data['profileId'];
      (this as any).globalEnabled = _data['globalEnabled'];
      (this as any).activityProfileViews = _data['activityProfileViews'];
      (this as any).activityFollowers = _data['activityFollowers'];
      (this as any).activityMessages = _data['activityMessages'];
      (this as any).activityRatings = _data['activityRatings'];
      (this as any).activityFrequency = _data['activityFrequency'];
      (this as any).summaryDaily = _data['summaryDaily'];
      (this as any).summaryWeekly = _data['summaryWeekly'];
      (this as any).marketingPromotions = _data['marketingPromotions'];
      (this as any).pushEnabled = _data['pushEnabled'];
      (this as any).emailEnabled = _data['emailEnabled'];
      (this as any).acceptPolicies = _data['acceptPolicies'];
      (this as any).acceptPoliciesTimestamp = _data['acceptPoliciesTimestamp'];
      (this as any).acceptNotifications = _data['acceptNotifications'];
    }
  }

  static fromJS(data: any): NotificationPreferences {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationPreferences();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileId'] = this.profileId;
    data['globalEnabled'] = this.globalEnabled;
    data['activityProfileViews'] = this.activityProfileViews;
    data['activityFollowers'] = this.activityFollowers;
    data['activityMessages'] = this.activityMessages;
    data['activityRatings'] = this.activityRatings;
    data['activityFrequency'] = this.activityFrequency;
    data['summaryDaily'] = this.summaryDaily;
    data['summaryWeekly'] = this.summaryWeekly;
    data['marketingPromotions'] = this.marketingPromotions;
    data['pushEnabled'] = this.pushEnabled;
    data['emailEnabled'] = this.emailEnabled;
    data['acceptPolicies'] = this.acceptPolicies;
    data['acceptPoliciesTimestamp'] = this.acceptPoliciesTimestamp;
    data['acceptNotifications'] = this.acceptNotifications;
    return data;
  }
}

export interface INotificationPreferences {
  profileId?: string;
  globalEnabled?: boolean;
  activityProfileViews?: boolean;
  activityFollowers?: boolean;
  activityMessages?: boolean;
  activityRatings?: boolean;
  activityFrequency?: string | undefined;
  summaryDaily?: boolean;
  summaryWeekly?: boolean;
  marketingPromotions?: boolean;
  pushEnabled?: boolean;
  emailEnabled?: boolean;
  acceptPolicies?: boolean | undefined;
  acceptPoliciesTimestamp?: string | undefined;
  acceptNotifications?: boolean | undefined;
}

export enum PaymentProvider {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum PaymentStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export class PersonalData implements IPersonalData {
  name?: string | undefined;
  lastName?: string | undefined;
  alias?: string | undefined;
  dateOfBirth?: Date;
  height?: number;
  weight?: number;
  laterality?: Laterality;

  constructor(data?: IPersonalData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.lastName = _data['lastName'];
      this.alias = _data['alias'];
      this.dateOfBirth = _data['dateOfBirth'] ? new Date(_data['dateOfBirth'].toString()) : (undefined as any);
      this.height = _data['height'];
      this.weight = _data['weight'];
      this.laterality = _data['laterality'];
    }
  }

  static fromJS(data: any): PersonalData {
    data = typeof data === 'object' ? data : {};
    let result = new PersonalData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['lastName'] = this.lastName;
    data['alias'] = this.alias;
    data['dateOfBirth'] = this.dateOfBirth ? this.dateOfBirth.toISOString() : (undefined as any);
    data['height'] = this.height;
    data['weight'] = this.weight;
    data['laterality'] = this.laterality;
    return data;
  }
}

export interface IPersonalData {
  name?: string | undefined;
  lastName?: string | undefined;
  alias?: string | undefined;
  dateOfBirth?: Date;
  height?: number;
  weight?: number;
  laterality?: Laterality;
}

export enum PersonalStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class Player implements IPlayer {
  personalData?: PersonalData;
  mainPosition?: PlayerPosition;
  otherPositions?: PlayerPosition[] | undefined;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;

  constructor(data?: IPlayer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.personalData = _data['personalData'] ? PersonalData.fromJS(_data['personalData']) : (undefined as any);
      this.mainPosition = _data['mainPosition'];
      if (Array.isArray(_data['otherPositions'])) {
        this.otherPositions = [] as any;
        for (let item of _data['otherPositions']) this.otherPositions!.push(item);
      }
      this.teamData = _data['teamData'] ? TeamData.fromJS(_data['teamData']) : (undefined as any);
      this.teamType = _data['teamType'];
      this.status = _data['status'];
      if (Array.isArray(_data['lastSeasonsData'])) {
        this.lastSeasonsData = [] as any;
        for (let item of _data['lastSeasonsData']) this.lastSeasonsData!.push(LastSeasonsData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Player {
    data = typeof data === 'object' ? data : {};
    let result = new Player();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['personalData'] = this.personalData ? this.personalData.toJSON() : (undefined as any);
    data['mainPosition'] = this.mainPosition;
    if (Array.isArray(this.otherPositions)) {
      data['otherPositions'] = [];
      for (let item of this.otherPositions) data['otherPositions'].push(item);
    }
    data['teamData'] = this.teamData ? this.teamData.toJSON() : (undefined as any);
    data['teamType'] = this.teamType;
    data['status'] = this.status;
    if (Array.isArray(this.lastSeasonsData)) {
      data['lastSeasonsData'] = [];
      for (let item of this.lastSeasonsData) data['lastSeasonsData'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IPlayer {
  personalData?: PersonalData;
  mainPosition?: PlayerPosition;
  otherPositions?: PlayerPosition[] | undefined;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;
}

export enum PlayerPosition {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class Profile implements IProfile {
  userId?: string | undefined;
  id?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  verified?: boolean;
  ratedCount?: number;
  rate?: number;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  introVideo?: string | undefined;
  introVideoThumbnail?: string | undefined;
  introVideoDuration?: number;
  name?: string | undefined;
  lastName?: string | undefined;
  alias?: string | undefined;
  email?: string | undefined;
  language?: string | undefined;
  blocks?: Block[] | undefined;
  readonly blocked?: boolean;
  deleted?: boolean;
  readonly registeredOn?: Date;
  readonly verifiedOn?: Date;
  readonly verifiedUntil?: Date | undefined;
  verifiedReason?: VerifiedReason;
  readonly deletedOn?: Date;

  constructor(data?: IProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.id = _data['id'];
      this.type = _data['type'];
      this.profileData = _data['profileData'];
      this.profilePicture = _data['profilePicture'];
      this.location = _data['location'] ? Location.fromJS(_data['location']) : (undefined as any);
      this.city = _data['city'];
      this.country = _data['country'];
      this.description = _data['description'];
      this.additionalInformation = _data['additionalInformation'];
      if (Array.isArray(_data['videos'])) {
        this.videos = [] as any;
        for (let item of _data['videos']) this.videos!.push(item);
      }
      this.verified = _data['verified'];
      this.ratedCount = _data['ratedCount'];
      this.rate = _data['rate'];
      this.rateTactic = _data['rateTactic'];
      this.ratePhysic = _data['ratePhysic'];
      this.rateTechnique = _data['rateTechnique'];
      this.rateMental = _data['rateMental'];
      this.rateCompromise = _data['rateCompromise'];
      this.introVideo = _data['introVideo'];
      this.introVideoThumbnail = _data['introVideoThumbnail'];
      this.introVideoDuration = _data['introVideoDuration'];
      this.name = _data['name'];
      this.lastName = _data['lastName'];
      this.alias = _data['alias'];
      this.email = _data['email'];
      this.language = _data['language'];
      if (Array.isArray(_data['blocks'])) {
        this.blocks = [] as any;
        for (let item of _data['blocks']) this.blocks!.push(Block.fromJS(item));
      }
      (this as any).blocked = _data['blocked'];
      this.deleted = _data['deleted'];
      (this as any).registeredOn = _data['registeredOn'] ? new Date(_data['registeredOn'].toString()) : (undefined as any);
      (this as any).verifiedOn = _data['verifiedOn'] ? new Date(_data['verifiedOn'].toString()) : (undefined as any);
      (this as any).verifiedUntil = _data['verifiedUntil'] ? new Date(_data['verifiedUntil'].toString()) : (undefined as any);
      this.verifiedReason = _data['verifiedReason'];
      (this as any).deletedOn = _data['deletedOn'] ? new Date(_data['deletedOn'].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): Profile {
    data = typeof data === 'object' ? data : {};
    let result = new Profile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['id'] = this.id;
    data['type'] = this.type;
    data['profileData'] = this.profileData;
    data['profilePicture'] = this.profilePicture;
    data['location'] = this.location ? this.location.toJSON() : (undefined as any);
    data['city'] = this.city;
    data['country'] = this.country;
    data['description'] = this.description;
    data['additionalInformation'] = this.additionalInformation;
    if (Array.isArray(this.videos)) {
      data['videos'] = [];
      for (let item of this.videos) data['videos'].push(item);
    }
    data['verified'] = this.verified;
    data['ratedCount'] = this.ratedCount;
    data['rate'] = this.rate;
    data['rateTactic'] = this.rateTactic;
    data['ratePhysic'] = this.ratePhysic;
    data['rateTechnique'] = this.rateTechnique;
    data['rateMental'] = this.rateMental;
    data['rateCompromise'] = this.rateCompromise;
    data['introVideo'] = this.introVideo;
    data['introVideoThumbnail'] = this.introVideoThumbnail;
    data['introVideoDuration'] = this.introVideoDuration;
    data['name'] = this.name;
    data['lastName'] = this.lastName;
    data['alias'] = this.alias;
    data['email'] = this.email;
    data['language'] = this.language;
    if (Array.isArray(this.blocks)) {
      data['blocks'] = [];
      for (let item of this.blocks) data['blocks'].push(item ? item.toJSON() : (undefined as any));
    }
    data['blocked'] = this.blocked;
    data['deleted'] = this.deleted;
    data['registeredOn'] = this.registeredOn ? this.registeredOn.toISOString() : (undefined as any);
    data['verifiedOn'] = this.verifiedOn ? this.verifiedOn.toISOString() : (undefined as any);
    data['verifiedUntil'] = this.verifiedUntil ? this.verifiedUntil.toISOString() : (undefined as any);
    data['verifiedReason'] = this.verifiedReason;
    data['deletedOn'] = this.deletedOn ? this.deletedOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IProfile {
  userId?: string | undefined;
  id?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  verified?: boolean;
  ratedCount?: number;
  rate?: number;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  introVideo?: string | undefined;
  introVideoThumbnail?: string | undefined;
  introVideoDuration?: number;
  name?: string | undefined;
  lastName?: string | undefined;
  alias?: string | undefined;
  email?: string | undefined;
  language?: string | undefined;
  blocks?: Block[] | undefined;
  blocked?: boolean;
  deleted?: boolean;
  registeredOn?: Date;
  verifiedOn?: Date;
  verifiedUntil?: Date | undefined;
  verifiedReason?: VerifiedReason;
  deletedOn?: Date;
}

export class ProfileReadModel implements IProfileReadModel {
  id?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  verified?: boolean;
  ratedCount?: number;
  rate?: number;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  introVideo?: string | undefined;
  introVideoThumbnail?: string | undefined;
  introVideoDuration?: number;

  constructor(data?: IProfileReadModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.profileData = _data['profileData'];
      this.profilePicture = _data['profilePicture'];
      this.location = _data['location'] ? Location.fromJS(_data['location']) : (undefined as any);
      this.city = _data['city'];
      this.country = _data['country'];
      this.description = _data['description'];
      this.additionalInformation = _data['additionalInformation'];
      if (Array.isArray(_data['videos'])) {
        this.videos = [] as any;
        for (let item of _data['videos']) this.videos!.push(item);
      }
      this.verified = _data['verified'];
      this.ratedCount = _data['ratedCount'];
      this.rate = _data['rate'];
      this.rateTactic = _data['rateTactic'];
      this.ratePhysic = _data['ratePhysic'];
      this.rateTechnique = _data['rateTechnique'];
      this.rateMental = _data['rateMental'];
      this.rateCompromise = _data['rateCompromise'];
      this.introVideo = _data['introVideo'];
      this.introVideoThumbnail = _data['introVideoThumbnail'];
      this.introVideoDuration = _data['introVideoDuration'];
    }
  }

  static fromJS(data: any): ProfileReadModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileReadModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['profileData'] = this.profileData;
    data['profilePicture'] = this.profilePicture;
    data['location'] = this.location ? this.location.toJSON() : (undefined as any);
    data['city'] = this.city;
    data['country'] = this.country;
    data['description'] = this.description;
    data['additionalInformation'] = this.additionalInformation;
    if (Array.isArray(this.videos)) {
      data['videos'] = [];
      for (let item of this.videos) data['videos'].push(item);
    }
    data['verified'] = this.verified;
    data['ratedCount'] = this.ratedCount;
    data['rate'] = this.rate;
    data['rateTactic'] = this.rateTactic;
    data['ratePhysic'] = this.ratePhysic;
    data['rateTechnique'] = this.rateTechnique;
    data['rateMental'] = this.rateMental;
    data['rateCompromise'] = this.rateCompromise;
    data['introVideo'] = this.introVideo;
    data['introVideoThumbnail'] = this.introVideoThumbnail;
    data['introVideoDuration'] = this.introVideoDuration;
    return data;
  }
}

export interface IProfileReadModel {
  id?: string;
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  verified?: boolean;
  ratedCount?: number;
  rate?: number;
  rateTactic?: number;
  ratePhysic?: number;
  rateTechnique?: number;
  rateMental?: number;
  rateCompromise?: number;
  introVideo?: string | undefined;
  introVideoThumbnail?: string | undefined;
  introVideoDuration?: number;
}

export enum ProfileType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export class ProfileView implements IProfileView {
  profile?: ProfileReadModel;
  viewedOn?: Date;

  constructor(data?: IProfileView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profile = _data['profile'] ? ProfileReadModel.fromJS(_data['profile']) : (undefined as any);
      this.viewedOn = _data['viewedOn'] ? new Date(_data['viewedOn'].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): ProfileView {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileView();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profile'] = this.profile ? this.profile.toJSON() : (undefined as any);
    data['viewedOn'] = this.viewedOn ? this.viewedOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IProfileView {
  profile?: ProfileReadModel;
  viewedOn?: Date;
}

export class RegisterProfile implements IRegisterProfile {
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  language?: string | undefined;

  constructor(data?: IRegisterProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.profileData = _data['profileData'];
      this.profilePicture = _data['profilePicture'];
      this.location = _data['location'] ? Location.fromJS(_data['location']) : (undefined as any);
      this.language = _data['language'];
    }
  }

  static fromJS(data: any): RegisterProfile {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['profileData'] = this.profileData;
    data['profilePicture'] = this.profilePicture;
    data['location'] = this.location ? this.location.toJSON() : (undefined as any);
    data['language'] = this.language;
    return data;
  }
}

export interface IRegisterProfile {
  type?: ProfileType;
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  location?: Location;
  language?: string | undefined;
}

export class ReportProfile implements IReportProfile {
  id?: string;
  reason?: string | undefined;

  constructor(data?: IReportProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.reason = _data['reason'];
    }
  }

  static fromJS(data: any): ReportProfile {
    data = typeof data === 'object' ? data : {};
    let result = new ReportProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['reason'] = this.reason;
    return data;
  }
}

export interface IReportProfile {
  id?: string;
  reason?: string | undefined;
}

export class RequestVerificationBody implements IRequestVerificationBody {
  additionalInfo?: string | undefined;

  constructor(data?: IRequestVerificationBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.additionalInfo = _data['additionalInfo'];
    }
  }

  static fromJS(data: any): RequestVerificationBody {
    data = typeof data === 'object' ? data : {};
    let result = new RequestVerificationBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['additionalInfo'] = this.additionalInfo;
    return data;
  }
}

export interface IRequestVerificationBody {
  additionalInfo?: string | undefined;
}

export class SearchCriteria implements ISearchCriteria {
  searchText?: string | undefined;
  yearRange?: YearRange;
  location?: Location;
  distanceInMeters?: number;
  profileTypes?: ProfileType[] | undefined;
  teamTypes?: TeamType[] | undefined;
  categories?: Category[] | undefined;
  personalStatus?: PersonalStatus[] | undefined;
  playerPositions?: PlayerPosition[] | undefined;
  staffPositions?: StaffPosition[] | undefined;
  lateralities?: Laterality[] | undefined;
  divisions?: Division[] | undefined;
  verified?: boolean | undefined;

  constructor(data?: ISearchCriteria) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.searchText = _data['searchText'];
      this.yearRange = _data['yearRange'] ? YearRange.fromJS(_data['yearRange']) : (undefined as any);
      this.location = _data['location'] ? Location.fromJS(_data['location']) : (undefined as any);
      this.distanceInMeters = _data['distanceInMeters'];
      if (Array.isArray(_data['profileTypes'])) {
        this.profileTypes = [] as any;
        for (let item of _data['profileTypes']) this.profileTypes!.push(item);
      }
      if (Array.isArray(_data['teamTypes'])) {
        this.teamTypes = [] as any;
        for (let item of _data['teamTypes']) this.teamTypes!.push(item);
      }
      if (Array.isArray(_data['categories'])) {
        this.categories = [] as any;
        for (let item of _data['categories']) this.categories!.push(item);
      }
      if (Array.isArray(_data['personalStatus'])) {
        this.personalStatus = [] as any;
        for (let item of _data['personalStatus']) this.personalStatus!.push(item);
      }
      if (Array.isArray(_data['playerPositions'])) {
        this.playerPositions = [] as any;
        for (let item of _data['playerPositions']) this.playerPositions!.push(item);
      }
      if (Array.isArray(_data['staffPositions'])) {
        this.staffPositions = [] as any;
        for (let item of _data['staffPositions']) this.staffPositions!.push(item);
      }
      if (Array.isArray(_data['lateralities'])) {
        this.lateralities = [] as any;
        for (let item of _data['lateralities']) this.lateralities!.push(item);
      }
      if (Array.isArray(_data['divisions'])) {
        this.divisions = [] as any;
        for (let item of _data['divisions']) this.divisions!.push(item);
      }
      this.verified = _data['verified'];
    }
  }

  static fromJS(data: any): SearchCriteria {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCriteria();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['searchText'] = this.searchText;
    data['yearRange'] = this.yearRange ? this.yearRange.toJSON() : (undefined as any);
    data['location'] = this.location ? this.location.toJSON() : (undefined as any);
    data['distanceInMeters'] = this.distanceInMeters;
    if (Array.isArray(this.profileTypes)) {
      data['profileTypes'] = [];
      for (let item of this.profileTypes) data['profileTypes'].push(item);
    }
    if (Array.isArray(this.teamTypes)) {
      data['teamTypes'] = [];
      for (let item of this.teamTypes) data['teamTypes'].push(item);
    }
    if (Array.isArray(this.categories)) {
      data['categories'] = [];
      for (let item of this.categories) data['categories'].push(item);
    }
    if (Array.isArray(this.personalStatus)) {
      data['personalStatus'] = [];
      for (let item of this.personalStatus) data['personalStatus'].push(item);
    }
    if (Array.isArray(this.playerPositions)) {
      data['playerPositions'] = [];
      for (let item of this.playerPositions) data['playerPositions'].push(item);
    }
    if (Array.isArray(this.staffPositions)) {
      data['staffPositions'] = [];
      for (let item of this.staffPositions) data['staffPositions'].push(item);
    }
    if (Array.isArray(this.lateralities)) {
      data['lateralities'] = [];
      for (let item of this.lateralities) data['lateralities'].push(item);
    }
    if (Array.isArray(this.divisions)) {
      data['divisions'] = [];
      for (let item of this.divisions) data['divisions'].push(item);
    }
    data['verified'] = this.verified;
    return data;
  }
}

export interface ISearchCriteria {
  searchText?: string | undefined;
  yearRange?: YearRange;
  location?: Location;
  distanceInMeters?: number;
  profileTypes?: ProfileType[] | undefined;
  teamTypes?: TeamType[] | undefined;
  categories?: Category[] | undefined;
  personalStatus?: PersonalStatus[] | undefined;
  playerPositions?: PlayerPosition[] | undefined;
  staffPositions?: StaffPosition[] | undefined;
  lateralities?: Laterality[] | undefined;
  divisions?: Division[] | undefined;
  verified?: boolean | undefined;
}

export class SearchResult implements ISearchResult {
  distance?: number;
  profile?: ProfileReadModel;

  constructor(data?: ISearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.distance = _data['distance'];
      this.profile = _data['profile'] ? ProfileReadModel.fromJS(_data['profile']) : (undefined as any);
    }
  }

  static fromJS(data: any): SearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new SearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['distance'] = this.distance;
    data['profile'] = this.profile ? this.profile.toJSON() : (undefined as any);
    return data;
  }
}

export interface ISearchResult {
  distance?: number;
  profile?: ProfileReadModel;
}

export class SendMessage implements ISendMessage {
  to?: string;
  content?: string | undefined;

  constructor(data?: ISendMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.to = _data['to'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): SendMessage {
    data = typeof data === 'object' ? data : {};
    let result = new SendMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['to'] = this.to;
    data['content'] = this.content;
    return data;
  }
}

export interface ISendMessage {
  to?: string;
  content?: string | undefined;
}

export class Staff implements IStaff {
  personalData?: PersonalData;
  position?: StaffPosition;
  otherStaffPositions?: StaffPosition[] | undefined;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;

  constructor(data?: IStaff) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.personalData = _data['personalData'] ? PersonalData.fromJS(_data['personalData']) : (undefined as any);
      this.position = _data['position'];
      if (Array.isArray(_data['otherStaffPositions'])) {
        this.otherStaffPositions = [] as any;
        for (let item of _data['otherStaffPositions']) this.otherStaffPositions!.push(item);
      }
      this.teamData = _data['teamData'] ? TeamData.fromJS(_data['teamData']) : (undefined as any);
      this.teamType = _data['teamType'];
      this.status = _data['status'];
      if (Array.isArray(_data['lastSeasonsData'])) {
        this.lastSeasonsData = [] as any;
        for (let item of _data['lastSeasonsData']) this.lastSeasonsData!.push(LastSeasonsData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Staff {
    data = typeof data === 'object' ? data : {};
    let result = new Staff();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['personalData'] = this.personalData ? this.personalData.toJSON() : (undefined as any);
    data['position'] = this.position;
    if (Array.isArray(this.otherStaffPositions)) {
      data['otherStaffPositions'] = [];
      for (let item of this.otherStaffPositions) data['otherStaffPositions'].push(item);
    }
    data['teamData'] = this.teamData ? this.teamData.toJSON() : (undefined as any);
    data['teamType'] = this.teamType;
    data['status'] = this.status;
    if (Array.isArray(this.lastSeasonsData)) {
      data['lastSeasonsData'] = [];
      for (let item of this.lastSeasonsData) data['lastSeasonsData'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IStaff {
  personalData?: PersonalData;
  position?: StaffPosition;
  otherStaffPositions?: StaffPosition[] | undefined;
  teamData?: TeamData;
  teamType?: TeamType;
  status?: PersonalStatus;
  lastSeasonsData?: LastSeasonsData[] | undefined;
}

export enum StaffPosition {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
  _14 = 14,
  _15 = 15,
}

export class TeamData implements ITeamData {
  teamName?: string | undefined;
  category?: Category;
  division?: Division;

  constructor(data?: ITeamData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.teamName = _data['teamName'];
      this.category = _data['category'];
      this.division = _data['division'];
    }
  }

  static fromJS(data: any): TeamData {
    data = typeof data === 'object' ? data : {};
    let result = new TeamData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['teamName'] = this.teamName;
    data['category'] = this.category;
    data['division'] = this.division;
    return data;
  }
}

export interface ITeamData {
  teamName?: string | undefined;
  category?: Category;
  division?: Division;
}

export enum TeamType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class UpdateNotificationPreferences implements IUpdateNotificationPreferences {
  globalEnabled?: boolean;
  activityProfileViews?: boolean;
  activityFollowers?: boolean;
  activityMessages?: boolean;
  activityRatings?: boolean;
  activityFrequency?: string | undefined;
  summaryDaily?: boolean;
  summaryWeekly?: boolean;
  marketingPromotions?: boolean;
  pushEnabled?: boolean;
  emailEnabled?: boolean;

  constructor(data?: IUpdateNotificationPreferences) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.globalEnabled = _data['globalEnabled'];
      this.activityProfileViews = _data['activityProfileViews'];
      this.activityFollowers = _data['activityFollowers'];
      this.activityMessages = _data['activityMessages'];
      this.activityRatings = _data['activityRatings'];
      this.activityFrequency = _data['activityFrequency'];
      this.summaryDaily = _data['summaryDaily'];
      this.summaryWeekly = _data['summaryWeekly'];
      this.marketingPromotions = _data['marketingPromotions'];
      this.pushEnabled = _data['pushEnabled'];
      this.emailEnabled = _data['emailEnabled'];
    }
  }

  static fromJS(data: any): UpdateNotificationPreferences {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateNotificationPreferences();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['globalEnabled'] = this.globalEnabled;
    data['activityProfileViews'] = this.activityProfileViews;
    data['activityFollowers'] = this.activityFollowers;
    data['activityMessages'] = this.activityMessages;
    data['activityRatings'] = this.activityRatings;
    data['activityFrequency'] = this.activityFrequency;
    data['summaryDaily'] = this.summaryDaily;
    data['summaryWeekly'] = this.summaryWeekly;
    data['marketingPromotions'] = this.marketingPromotions;
    data['pushEnabled'] = this.pushEnabled;
    data['emailEnabled'] = this.emailEnabled;
    return data;
  }
}

export interface IUpdateNotificationPreferences {
  globalEnabled?: boolean;
  activityProfileViews?: boolean;
  activityFollowers?: boolean;
  activityMessages?: boolean;
  activityRatings?: boolean;
  activityFrequency?: string | undefined;
  summaryDaily?: boolean;
  summaryWeekly?: boolean;
  marketingPromotions?: boolean;
  pushEnabled?: boolean;
  emailEnabled?: boolean;
}

export class UpdateProfile implements IUpdateProfile {
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  location?: Location;

  constructor(data?: IUpdateProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileData = _data['profileData'];
      this.profilePicture = _data['profilePicture'];
      this.city = _data['city'];
      this.country = _data['country'];
      this.description = _data['description'];
      this.additionalInformation = _data['additionalInformation'];
      if (Array.isArray(_data['videos'])) {
        this.videos = [] as any;
        for (let item of _data['videos']) this.videos!.push(item);
      }
      this.location = _data['location'] ? Location.fromJS(_data['location']) : (undefined as any);
    }
  }

  static fromJS(data: any): UpdateProfile {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileData'] = this.profileData;
    data['profilePicture'] = this.profilePicture;
    data['city'] = this.city;
    data['country'] = this.country;
    data['description'] = this.description;
    data['additionalInformation'] = this.additionalInformation;
    if (Array.isArray(this.videos)) {
      data['videos'] = [];
      for (let item of this.videos) data['videos'].push(item);
    }
    data['location'] = this.location ? this.location.toJSON() : (undefined as any);
    return data;
  }
}

export interface IUpdateProfile {
  profileData?: string | undefined;
  profilePicture?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  additionalInformation?: string | undefined;
  videos?: string[] | undefined;
  location?: Location;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  errors?: { [key: string]: string[] } | undefined;

  [key: string]: any;

  constructor(data?: IValidationProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
      if (_data['errors']) {
        this.errors = {} as any;
        for (let key in _data['errors']) {
          if (_data['errors'].hasOwnProperty(key)) (this.errors as any)![key] = _data['errors'][key] !== undefined ? _data['errors'][key] : [];
        }
      }
    }
  }

  static fromJS(data: any): ValidationProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    if (this.errors) {
      data['errors'] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key)) (data['errors'] as any)[key] = (this.errors as any)[key];
      }
    }
    return data;
  }
}

export interface IValidationProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  errors?: { [key: string]: string[] } | undefined;

  [key: string]: any;
}

export enum VerificationRequestStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum VerifiedReason {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class YearRange implements IYearRange {
  from?: number | undefined;
  to?: number | undefined;

  constructor(data?: IYearRange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data['from'];
      this.to = _data['to'];
    }
  }

  static fromJS(data: any): YearRange {
    data = typeof data === 'object' ? data : {};
    let result = new YearRange();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['from'] = this.from;
    data['to'] = this.to;
    return data;
  }
}

export interface IYearRange {
  from?: number | undefined;
  to?: number | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
